import { render, staticRenderFns } from "./selfEvaluation.vue?vue&type=template&id=4a585d2e&scoped=true&"
import script from "./selfEvaluation.vue?vue&type=script&lang=js&"
export * from "./selfEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./selfEvaluation.vue?vue&type=style&index=0&id=4a585d2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a585d2e",
  null
  
)

component.options.__file = "selfEvaluation.vue"
export default component.exports